// noinspection JSUnusedGlobalSymbols
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs';

import { initializingMasterDataStore } from 'app/state/master-data/master-data.actions';
import { selectMasterData } from 'app/state/master-data/master-data.selectors';
import { updateProductBoxes } from 'app/state/product-boxes/product-box.actions';

// noinspection JSUnusedGlobalSymbols
@Injectable()
export class ProductBoxEffects {
    syncWithMasterDataStore$ = createEffect(() =>
        this.actions$.pipe(
            ofType(initializingMasterDataStore),
            switchMap(() => this.store.select(selectMasterData)),
            map((masterData) => updateProductBoxes({ productBoxList: masterData?.productBoxes ?? [] })),
        ),
    );
    constructor(
        private actions$: Actions,
        private store: Store,
    ) {}
}
